import React from 'react';
const EntryPointSection = () => {
  return <section className="w-full py-16 bg-gradient-to-r from-navy-900 to-navy-800 observer-element" data-id="element-78">
      <div className="container mx-auto px-4" data-id="element-79">
        <div className="max-w-3xl mx-auto text-center" data-id="element-80">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gold-400 mb-8 animate-pulse" data-id="element-81">
            🚨 DON'T MISS YOUR ENTRY POINT 🚨
          </h2>
          <div className="space-y-6 mb-8" data-id="element-82">
            <p className="text-xl sm:text-2xl text-white fade-in" data-id="element-83">
              Most people stay stuck not because they're unqualified —
            </p>
            <p className="text-xl sm:text-2xl text-white fade-in" data-id="element-84">
              but because they never get in the right room.
            </p>
          </div>
          <div className="mt-12 space-y-4" data-id="element-85">
            <p className="text-2xl sm:text-3xl font-semibold text-gradient fade-in" data-id="element-86">
              Legacy Lab is that room.
            </p>
            <p className="text-xl italic text-gold-400 fade-in" data-id="element-87">
              And seats are always limited… by design.
            </p>
          </div>
          <div className="mt-12" data-id="element-88">
            <a href="#programs" className="btn-navy-gold" data-id="element-89">
              Explore Our Programs
            </a>
          </div>
        </div>
      </div>
    </section>;
};
export default EntryPointSection;